import { useState } from 'react';
import { useAppDispatch } from '../../useAppDispatch';
import { useUpdateSubscriptionMutation } from '../service';
import { refreshAccessToken } from '../../store/iam/operations';
import { notification } from 'antd';

export default function useUpdateSubscription() {
    const dispatch = useAppDispatch();
    const [updatedPlanCode, setUpdatedPlanCode] = useState<string>('');

    const [updateSubscriptionTrigger, { isLoading: isUpdatingSubscription }] = useUpdateSubscriptionMutation();

    const updateSubscription = async (planCode: string) => {
        try {
            setUpdatedPlanCode(planCode);
            const response = await updateSubscriptionTrigger({ plan_code: planCode }).unwrap();

            if ('error' in response) {
                throw new Error();
            }

            await dispatch(refreshAccessToken()); // TODO Refactor this after IAM
        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'We cannot update your subscription. Please try again or contact support!',
            });
        } finally {
            setUpdatedPlanCode('');
        }
    };

    return {
        updateSubscription,
        updatedPlanCode,
        isUpdatingSubscription,
    };
}
